import React, { Component } from 'react';
import axios from 'axios';
import { game_matchup } from '~/tools/mll/headers';
import { reduceMetadata } from '~/tools/mll/helpers';
import './MatchupGame.css';
import _ from 'lodash';

class MatchupGame extends Component {
  state = {
    matchup: []
  }

  componentDidMount = () => {
    const page = this.props.page;
    const meta = reduceMetadata(_.get(page, 'metadata', []));
    axios.get(`/season/standings/${meta.seasonID}`).then((res) => {
      const teams = res.data.seasonData.standings.team;
      const away = teams.filter(el => el.teamid === page.awayTeam.gist.dataId);
      const home = teams.filter(el => el.teamid === page.homeTeam.gist.dataId);

      this.setState({
        matchup: [
          away,
          home
        ]
      })
    }).catch((err) => {
      console.log(err);
    })
  }

  render() {
    return (
      <div className='matchup-wrapper'>
        <div className='preview'>
          <h3 className='preview-title site-border-color'>Preview</h3>
          <div className='preview-paragraph' dangerouslySetInnerHTML={{
            __html: `${this.props.page.body || 'Coming soon.'}`
          }} />
        </div>
        <div className='matchup-summary'>
          <h3 className='matchup-summary-title site-border-color'>Matchup</h3>
          {this.state.matchup.map((matchup, i) => (
            matchup.map((item, i) => (
              <div className='team' key={i}>
                <span className='team-name'>{item.mascot}</span>
                <span className='team-standing'>{item.wins} - {item.losses}</span>
                <div className='team-wrapper'>
                  {game_matchup[0].map((header, i) => (
                    <div key={i}>
                      <span>{header}</span>
                      <span>
                        <b>{item[game_matchup[1][i]]}</b>
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            ))            
          ))}
        </div>
      </div>
    )
  }
}

export default MatchupGame;